// extracted by css-extract-rspack-plugin
export default {"card":"GeneralTabPanel_card__rORim","container":"GeneralTabPanel_container__K+ij3","panel":"GeneralTabPanel_panel__OTjpq"};